import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchApiTokens } from '#/modules/orgDashboard/api/orgDashboardApiFetchApiTokens';
import { orgDashboardApiAccessRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardApiAccessPageLoadable } from './OrgDashboardApiAccessPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardApiAccessRoute>) {
  const [{ apiTokens, hasApi }] = await Promise.all([
    orgDashboardApiIsomorphicFetchApiTokens({ request, context })(orgId),
    OrgDashboardApiAccessPageLoadable.load(),
  ]);

  return { apiTokens, hasApi };
}

export default function OrgDashboardApiAccessHorizonRoute({
  loaderData: { apiTokens, hasApi },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('API Documentation and Sandbox')}>
      <OrgDashboardApiAccessPageLoadable
        apiTokens={apiTokens}
        hasApi={hasApi}
      />
    </RouteModule>
  );
}
